export default "__VITE_ASSET__CTrWDUCT__"